<h3> SUBMISSION </h3>
<ul style="list-style-type: none">
	<li> Submission deadline: <b>7th May, 2024</b> </li>
	<li> Preliminary acceptance notification: 2nd July, 2024 </li>
	<li> Final acceptance notification: 9th July, 2024 </li>
</ul>
<p>
	Conference contributions can be submitted via EasyChair
	using the following link <a
		href="https://easychair.org/conferences/?conf=cifris24">https://easychair.org/conferences/?conf=cifris24</a>.
</p>